import dayjs from 'dayjs';

export function formatPublishedAt(publishedAt: Date | string) {
  return dayjs(publishedAt).format('DD MMM YYYY');
}

export function formatDuration(seconds: number) {
  return Math.round(seconds / 60 - 0.01);
}

export function getVisibleUserTags(userTags: UserTag[] = []): UserTag[] {
  return userTags.filter(tag => tag.is_visible !== false);
}
